const doc = [({"zh_cn":({"adminComponentCompanyPayment":({"companyPaymentIndexTitle":"付款清单", "companyPaymentSummaryIndexTitle":"付款摘要", "showTargetBooking":"查看符合条件的预订"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;